import { Dialog } from "@blueprintjs/core";
import { QuanLyVanBan } from 'api';
import DataTable from 'components/data-table';
import { Input, TextArea } from 'components/tt-forms/common';
import { msg } from 'constants/message';
import { header } from 'constants/table';
import { MasterLayout } from 'layout';
import { Toastr } from 'modules/toastr';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import SearchTheLoaiVanBan from './SearchTheLoaiVanBan.jsx';
import { RowItemTheLoaiVanBan } from './datatable';
import { API_URL } from 'constants/config';
import { exportExcel } from "constants/exportExcel";

class TheLoaiVanBan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      tenLoaiVanBan: '',
      isValid: true,
      moTa: '',
      idLoaiVanBan: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tenVanBan: '',
      search: false
    };
  }

  componentDidMount() {
    this.getListData();
  }

  handleSearch() {
    this.setState({
      search: true,
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: isSearch ? 0 : this.state.pageData.number,
      size: this.state.pageData.size,
    }
    if (this.state.tenVanBan) {
      params.tenVanBan = this.state.tenVanBan.trim();
    }
    QuanLyVanBan.actions.getLoaiVanBan.request(null, params).then(res => {
      if (res.data) {
        this.setState({
          data: res.data.contents,
          pageData: {
            number: res.data.pageNumber,
            size: res.data.pageSize,
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages
          },
          tableLoading: false,
          searchLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false,
          searchLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  createCategory() {
    if (this.checkValidate()) {
      let params = {
        tenLoaiVanBan: this.state.tenLoaiVanBan.trim(),
        moTa: this.state.moTa.trim()
      };

      this.setState({ buttonLoading: true });
      if (this.state.addType == 2) {
        QuanLyVanBan.actions.putLoaiVanBan.request({ id: this.state.idLoaiVanBan }, params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.updateCategorySucess, 'success');
          this.setState({ buttonLoading: false });
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
            this.setState({ buttonLoading: false });
          }
        });
      } else {
        QuanLyVanBan.actions.postLoaiVanBan.request('', params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.addCategorySucess, 'success');
          this.setState({ buttonLoading: false });
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
            this.setState({ buttonLoading: false });
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }

  componentWillUnmount() {
    this.props.validators['danhMuc'] = [];
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(idLoaiVanBan) {
    if (idLoaiVanBan) {
      this.setState({ buttonLoading: true });
      QuanLyVanBan.actions.deleteLoaiVanBan.request({ id: idLoaiVanBan }).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess, 'success');
        this.setState({ buttonLoading: false });
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].description, 'error');
          this.setState({ buttonLoading: false });
        }
      });
    }
  }
  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  checkValidate() {
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  toggleDialog() {
    this.setState({ popupAddCategory: !this.state.popupAddCategory });
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {
    this.toggleDialog();
    this.setState({
      addType: 0,
      tenLoaiVanBan: '',
      moTa: '',
      isValid: true
    });
  }

  openUpdateCategory(item) {
    this.toggleDialog();
    this.setState({
      addType: 2,
      idLoaiVanBan: item.id,
      tenLoaiVanBan: item.tenLoaiVanBan,
      moTa: item.moTa || '',
      isValid: true
    });
  }

  handleExport() {
    const URL = String(API_URL) + "/loai-van-ban"
    exportExcel(URL, 'theloaivanban.xlsx');
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Thể loại văn bản</p>
            </div>
            <div className="right-content">
              <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
            </div>
          </div>
          <div className="bottom-content">
            <SearchTheLoaiVanBan parents={this} />
            <DataTable
              header={header.quanLyVanBan.dsTheLoaiVanBan}
              dataList={this.state.data}
              pageData={this.state.pageData}
              handleExport={this.handleExport.bind(this)}
              exporttext="Xuất Excel"
              thanhTra
              hideButtonExport={true}
              parent={this}
              search={this.state.search}
              tableLoading={this.state.tableLoading}
            >
              <RowItemTheLoaiVanBan />
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.toggleDialog.bind(this)}
            title={this.state.addType == 2 ? 'Chỉnh sửa loại văn bản' : 'Thêm mới loại văn bản'}
            iconName="add-new"
            className="panel-popup category medium">
            <div className="pt-dialog-body">
              <Input className="" placeholder="Nhập tên thể loại văn bản" label="Tên thể loại văn bản" value={this.state.tenLoaiVanBan} require={true} maxLength={40} onChange={this.onChange.bind(this, 'tenLoaiVanBan')}
                bindValidator={this} channel="danhMuc" />
              <TextArea placeholder="Nhập mô tả" label="Mô tả" maxLength={255} rows={5} value={this.state.moTa} onChange={this.onChange.bind(this, 'moTa')} className='' />
            </div>
            <div className="pt-dialog-footer">
              <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                <span>Đóng</span>
              </Link>
              <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)}>
                <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}

TheLoaiVanBan.defaultProps = {
  validators: {}
}

function bindStateToProps(state) {
  return {};
}

export default connect(bindStateToProps)(TheLoaiVanBan);



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-van-ban/TheLoaiVanBan.jsx